/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import toast from '@/services/toast';
import {
  bus
} from '@/main';
export default {
  name: 'request-for-member-popup',
  components: {},
  props: ['requestMemberInfo'],
  data () {
    return {
      selfUserId:'',
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    requestMemberPopupCloseMethod(){
      bus.$emit('requestMemberPopupStateBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
    sentRequestMemberMethod(){
      this.submitted = true
      let data = {
        added_by_user:this.selfUserId,
        sub_user_accepted:false
      }
      this.$store.dispatch('updateUserInfoForTeamFun', {data:{data: data, id: this.requestMemberInfo.id}})
        .then((res) => {  
          this.submitted = false
          toast.success(res.data.msg);    
          this.requestMemberPopupCloseMethod()     
        }).catch((err) => {
          toast.error(err.data.msg);
          this.submitted = false
        })
    }
  }
}


